import React, { useEffect, useState } from 'react';
import { fetchTokens, fetchTokenDetails } from '../services/tokensService';
import './slot-machine/slot-machine.scss';

interface Token {
    image: string;
    name: string;
    symbol: string;
    url: string;
}

interface ModalTokensProps {
    isOpen: boolean;
    onClose: () => void;
}

const ModalTokens: React.FC<ModalTokensProps> = ({ isOpen, onClose }) => {
    const [tokens, setTokens] = useState<Token[]>([]);
    const [mintAddress, setMintAddress] = useState('');
    const [newTokenDetails, setNewTokenDetails] = useState<any | null>(null);

    useEffect(() => {
        if (isOpen) {
            fetchTokens().then(data => setTokens(data));
        }
    }, [isOpen]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const tokenDetails = await fetchTokenDetails(mintAddress);
            // if there is a message in the tokenDetails, alert that message, else display the new token details
            setNewTokenDetails(tokenDetails);
        } catch {
            // Handle error
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <h2>Tokens in Slot Machine</h2>
                <div className="token-gallery">
                    {tokens.map(token => (
                        <div key={token.symbol} className="token-item">
                            <a href={token.url}>
                                <img src={token.image} alt={token.name} />
                                <p>${token.symbol.startsWith('$') ? token.symbol.slice(1) : token.symbol}</p>
                            </a>
                        </div>
                    ))}
                </div>
                <form onSubmit={handleSubmit} className="add-token-form">
                    <h3>Add Moonshot Token</h3>
                    <input
                        type="text"
                        placeholder="Mint Address"
                        value={mintAddress}
                        onChange={e => setMintAddress(e.target.value)}
                        required
                    />
                    <button type="submit">Fetch Details</button>
                </form>
                {newTokenDetails && (
                    <>
                    <div className="token-details" style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={newTokenDetails.token.image} alt={newTokenDetails.token.name} style={{ marginRight: '10px' }} />
                        <p><b>{newTokenDetails.token.name}</b> {newTokenDetails.token.symbol}</p>
                        
                    </div>
                    {newTokenDetails.message ? (
                            <p>{newTokenDetails.message}</p>
                        ): <></> }
                    </>
                )}
                <button className="close-button" onClick={onClose}>Close</button>
            </div>
        </div>
    );
};

export default ModalTokens;